import { Model } from '@models/core/base.model';
import { TenantCreationStatus } from '@payroll/enums/tenant-creation-status.enum';

export class Tenant extends Model {
    static _resource = 'payroll/tenants';

    get creationStatus(): TenantCreationStatus {
        return this._attributes['creationStatus'];
    }
}
